module.exports = __webpack_public_path__ + "images/10988e7f7aebb287eeccadcdb0fae983b0399e514a795ac9fb5ef7621edea5bc.svg";